(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elcommun-ranking"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.ec-rank-tab');
  if (!btn) return;
  var root = btn.closest('.ec-ranking');
  if (!root) return;
  var idx = btn.getAttribute('data-idx');
  root.querySelectorAll('.ec-rank-tab').forEach(function (b) {
    b.classList[b === btn ? 'add' : 'remove']('active');
  });
  root.querySelectorAll('.ec-rank-pane').forEach(function (p) {
    p.classList[p.getAttribute('data-idx') === idx ? 'add' : 'remove']('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
